import * as React from 'react'

import {
  Button,
  EmptyState,
  SkeletonText,
  VisuallyHidden,
} from '@buffer-mono/popcorn'

import { PostCardSkeleton } from '~publish/components/PostCard'
import { PostingTimeline } from '~publish/components/PostingTimeline'
import { range } from '~publish/helpers/range'

import { PostListEmptyStateIllustration } from './PostListEmptyStateIllustration'
import { SeparatorHeaderSkeleton } from '../../../components/DateSeparator'

import type { JSX } from 'react'

export const PostListSkeleton = (): JSX.Element => (
  <PostingTimeline role="feed" aria-busy>
    <VisuallyHidden>Loading posts</VisuallyHidden>
    {range(20).map((index) => (
      <React.Fragment key={index}>
        {index % 3 === 0 ? <SeparatorHeaderSkeleton /> : null}
        <PostingTimeline.Entry>
          <PostingTimeline.Label>
            <SkeletonText lines={1} width="6ch" />
          </PostingTimeline.Label>
          <PostingTimeline.Content>
            <PostCardSkeleton />
          </PostingTimeline.Content>
        </PostingTimeline.Entry>
      </React.Fragment>
    ))}
  </PostingTimeline>
)

export const PostListEmptyState = (): JSX.Element => {
  return (
    <EmptyState size="large">
      <PostListEmptyStateIllustration />
      <EmptyState.Heading>No posts found</EmptyState.Heading>
      <EmptyState.Description>
        There are no posts that meet your selected filters
      </EmptyState.Description>
    </EmptyState>
  )
}

export const FilteredPostListEmptyState = ({
  onClearFilters,
}: {
  onClearFilters: () => void
}): JSX.Element => (
  <EmptyState size="large">
    <PostListEmptyStateIllustration />
    <EmptyState.Heading>No posts found</EmptyState.Heading>
    <EmptyState.Description>
      There are no posts that meet your selected filters
    </EmptyState.Description>
    <EmptyState.Actions>
      <Button variant="secondary" onClick={onClearFilters}>
        Clear Filters
      </Button>
    </EmptyState.Actions>
  </EmptyState>
)
